module.exports = __webpack_public_path__ + "img/inco3Ac.2d0e1226.png";